import styled from "styled-components";
import PButton from "../../../components/PButton";

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 550px;
  z-index: 1;

  @media only screen and (max-width: 768px) {
    height: 394px;
  }

  @media only screen and (max-width: 768px) {
    height: 278px;
  }
`;

export const FormContainer = styled.div`
  width: 430px;
  height: 100%;
  position: absolute;
  right: 0;
  background-color: ${({ theme }) => theme.white};
`;

export const ScheduleSectionContainer = styled.div`
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  position: absolute;
  bottom: -50px;

  @media only screen and (max-width: 768px) {
    bottom: -100px;
  }
`;

export const ScheduleSection = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: ${({ theme }) => theme.colors.lightGray2};

  @media only screen and (max-width: 560px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 30px;
    padding-right: 30px;
  }
`;

export const ScheduleSummary = styled.div`
  font-family: "Helvetica";
  font-size: 20px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
  max-width: 280px;

  @media only screen and (max-width: 560px) {
    font-size: 16px;
    text-align: center;
  }
`;

export const BtnWrap = styled.div`
  width: 200px;

  @media only screen and (max-width: 560px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    padding-top: 10px;
  }
`;

export const CustomButton = styled(PButton)`
  height: 60px;

  @media only screen and (max-width: 560px) {
    height: 46px;
  }
`;